import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Technology from "@/pages/Technology";
import Careers from "@/pages/Careers";
import Blog from "@/pages/Blog";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import BookLoad from "@/pages/BookLoad";
import TrackShipment from "@/pages/TrackShipment";
import ToolsIndex, { ToolPage, TOOLS } from "@/pages/Tools";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import CustomerPortal from "@/pages/portal/CustomerPortal";
import CarrierPortal from "@/pages/portal/CarrierPortal";
import AdminDashboard from "@/pages/portal/AdminDashboard";
import TmsPortal from "@/pages/portal/TmsPortal";

function Chrome({ children }) {
  const loc = useLocation();
  const noChrome = loc.pathname.startsWith("/portal") ||
    loc.pathname === "/login" || loc.pathname === "/register" || loc.pathname === "/auth/callback";
  return (
    <>
      {!noChrome && <Navbar />}
      <main>{children}</main>
      {!noChrome && <Footer />}
    </>
  );
}

function AppRouter() {
  const loc = useLocation();
  // Emergent Google Auth returns session_id via URL fragment on any page.
  if (loc.hash?.includes("session_id=") && loc.pathname !== "/auth/callback") {
    return <AuthCallback />;
  }
  return (
    <Chrome>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/technology" element={<Technology />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/quote" element={<RequestQuote />} />
        <Route path="/book" element={<BookLoad />} />
        <Route path="/track" element={<TrackShipment />} />
        <Route path="/tools" element={<ToolsIndex />} />
        {TOOLS.map(t => (
          <Route key={t.slug} path={`/tools/${t.slug}`} element={<ToolPage tool={t} />} />
        ))}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/portal/customer/*" element={<ProtectedRoute role="customer"><CustomerPortal /></ProtectedRoute>} />
        <Route path="/portal/carrier/*" element={<ProtectedRoute role="carrier"><CarrierPortal /></ProtectedRoute>} />
        <Route path="/portal/admin/*" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
        <Route path="/portal/tms/*" element={<ProtectedRoute anyOf={["admin", "dispatcher", "biller"]}><TmsPortal /></ProtectedRoute>} />
      </Routes>
    </Chrome>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
